import router from "./router";
import { getToken, setToken } from "@/utils/auth";
import { getQueryString } from "@/utils/location";

// 监听路由跳转，如果有参数着带入下一个路由
router.beforeEach(async (to, from, next) => {
  if (getQueryString("token")) {
    setToken(getQueryString("token"));
  }
  // 判断用户是否已登录
  const hasToken = getToken();
  // console.log(hasToken)
  // 部分页面需要登录权限
  if (to.matched.some((res) => res.meta.isLogin)) {
    //判断是否需要登录
    if (from.query.key) {
      let toQuery = JSON.parse(JSON.stringify(to.query));
      toQuery.key = from.query.key;
      if (getQueryString("invateUid")) {
        toQuery.invateUid = getQueryString("invateUid");
      }

      next({
        path: "/login",
        query: toQuery,
      });
    } else {
      let toQuery = JSON.parse(JSON.stringify(to.query));
      toQuery.key = "C7WglmY9";
      next({
        path: "/login",
        query: toQuery,
      });
    }
  } else {
    // 登录状态下获取用户信息
    //store.dispatch('getInfo')
    // 每个页面设置渠道
    if (to.query.key) {
      next();
      return;
    }
    if (from.query.key) {
      let toQuery = JSON.parse(JSON.stringify(to.query));
      toQuery.key = from.query.key;
      toQuery.invateUid = from.query.invateUid;
      next({
        path: to.path,
        query: toQuery,
      });
    } else {
      let toQuery = JSON.parse(JSON.stringify(to.query));
      toQuery.key = "C7WglmY9";
      if (getQueryString("invateUid")) {
        toQuery.invateUid = getQueryString("invateUid");
      }
      next({
        path: to.path,
        query: toQuery,
      });
    }
  }
});
